import type { Thing, WithContext } from 'schema-dts';

export const SITE_NAME = 'Vonlof';
export const SITE_URL = (import.meta.env.VITE_SITE_URL as string | undefined) ?? 'https://vonlof.co';
export const SITE_DESCRIPTION =
  'Vonlof is a Ghana-based software studio designing and engineering products for ambitious teams across Africa — and the world.';

export function absoluteUrl(path: string): string {
  if (path.startsWith('http')) return path;
  return new URL(path, SITE_URL).toString();
}

export function organizationSchema(): WithContext<Thing> {
  return {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: SITE_NAME,
    legalName: 'Vonlof',
    url: SITE_URL,
    logo: absoluteUrl('/og/default.png'),
    description: SITE_DESCRIPTION,
    address: {
      '@type': 'PostalAddress',
      addressLocality: 'Accra',
      addressCountry: 'GH',
    },
    contactPoint: [
      {
        '@type': 'ContactPoint',
        contactType: 'customer support',
        email: 'contact@vonlof.co',
        telephone: '+233-20-558-1981',
        areaServed: ['GH', 'Africa', 'Worldwide'],
        availableLanguage: ['English'],
      },
    ],
    sameAs: [],
  };
}

export function websiteSchema(): WithContext<Thing> {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: SITE_NAME,
    url: SITE_URL,
    description: SITE_DESCRIPTION,
    inLanguage: 'en',
  };
}